<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUISettings } from 'dashboard/composables/useUISettings';

import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const { uiSettings, updateUISettings } = useUISettings();

// Persisted per-user preference; when on, blocked contacts are filtered out
// server-side (see ContactsController#resolved_contacts).
const hideBlocked = computed(
  () => uiSettings.value?.hide_blocked_contacts || false
);

const label = computed(() =>
  hideBlocked.value
    ? t('CONTACTS_LAYOUT.HEADER.SHOW_BLOCKED')
    : t('CONTACTS_LAYOUT.HEADER.HIDE_BLOCKED')
);

const toggle = () => {
  updateUISettings({ hide_blocked_contacts: !hideBlocked.value });
};
</script>

<template>
  <Button
    v-tooltip.top="label"
    :aria-label="label"
    icon="i-lucide-ban"
    color="slate"
    size="sm"
    variant="ghost"
    class="w-8"
    :class="hideBlocked ? 'bg-n-alpha-2 !text-[#F40009]' : ''"
    @click="toggle"
  />
</template>
